import { useState } from "react";
import { AddClientDialog } from "./add-client-dialog";
import { EditClientDialog } from "./edit-client-dialog";
import { DeleteClientDialog } from "./delete-client-dialog";
import ClientsTable from "./clients-table";
import type { Client } from "@/types/clients/api-types/client-types";

export const ClientsTabContent = () => {
  const [selectedClient, setSelectedClient] = useState<Client | null>(null);
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
  const [clientToDelete, setClientToDelete] = useState<Client | null>(null);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);

  const handleClientClick = (client: Client) => {
    setSelectedClient(client);
    setIsEditDialogOpen(true);
  };

  const handleEditDialogClose = (open: boolean) => {
    setIsEditDialogOpen(open);
    if (!open) {
      setSelectedClient(null);
    }
  };

  const handleDeleteClick = (client: Client) => {
    setClientToDelete(client);
    setIsDeleteDialogOpen(true);
  };

  const handleDeleteDialogClose = (open: boolean) => {
    setIsDeleteDialogOpen(open);
    if (!open) {
      setClientToDelete(null);
    }
  };

  return (
    <div className="mt-5">
      <div className="flex justify-end mb-4 pr-4">
        <AddClientDialog />
      </div>
      <ClientsTable
        onClientClick={handleClientClick}
        onDeleteClick={handleDeleteClick}
      />
      {selectedClient && (
        <EditClientDialog
          client={selectedClient}
          open={isEditDialogOpen}
          onOpenChange={handleEditDialogClose}
        />
      )}
      {clientToDelete && (
        <DeleteClientDialog
          client={clientToDelete}
          open={isDeleteDialogOpen}
          onOpenChange={handleDeleteDialogClose}
        />
      )}
    </div>
  );
};
